import script from "./cover.vue?vue&type=script&setup=true&lang=js"
export * from "./cover.vue?vue&type=script&setup=true&lang=js"

import "./cover.vue?vue&type=style&index=0&id=8072a09e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8072a09e"]])

export default __exports__